import UserDeleteModal from '@/components/UserDeleteModal.vue'

// Cableado compartido del modal de eliminar usuario en las fichas de
// /usuarios/:id. La pestaña "Eliminar usuario" del TabNav ya no navega a una
// vista propia: emite la acción 'delete' y la confirmación ocurre sin sacar al
// administrador de la ficha en la que estaba.
export const userDeleteModal = {
  components: { UserDeleteModal },
  data() {
    return {
      showDeleteModal: false
    }
  },
  computed: {
    // El nombre puede no estar cargado todavía; el modal cae a "este usuario".
    deleteModalUserName() {
      const user = this.user || {}
      return ((user.firstname || '') + ' ' + (user.lastname || '')).trim()
    }
  },
  methods: {
    onNavAction(action) {
      if (action === 'delete') this.showDeleteModal = true
    },
    closeDeleteModal() {
      this.showDeleteModal = false
    },
    onUserDeleted() {
      this.showDeleteModal = false
      // La ficha que estábamos viendo ya no existe: volver al listado.
      this.$router.push('/usuarios')
    }
  }
}
